import { type UserLite } from '../../resources/User/types';
import { type HttpClient } from '../useHttpClient';

export const getUserByPhoneNumber =
  (httpClient: HttpClient) => async (phoneNumber: string) => {
    const response = await httpClient.api(
      `/admin/users/getByPhoneNumber/${phoneNumber}`,
      {
        method: 'GET',
      }
    );

    return response.body ? (response.json as UserLite) : undefined;
  };
